import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Festival from './pages/Festival';
import FestivalsPage from './pages/FestivalsPage';
import ShomalAIFestival from './pages/ShomalAIFestival';
import Admin from './pages/Admin';
import DownloadApp from './pages/DownloadApp';
import GalleryPage from './pages/GalleryPage';
import UserLogin from './pages/UserLogin';
import UserDashboard from './pages/UserDashboard';
import Novayar from './pages/Novayar';
import NovayarAdmin from './pages/NovayarAdmin';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <div className="App min-h-screen flex flex-col transition-colors duration-300">
          <Header />
          <main className="flex-grow pt-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/festivals" element={<FestivalsPage />} />
              <Route path="/festival" element={<Festival />} />
              <Route path="/shomal-ai" element={<ShomalAIFestival />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/download-app" element={<DownloadApp />} />
              <Route path="/user/login" element={<UserLogin />} />
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/novayar" element={<Novayar />} />
              <Route path="/novayar-admin" element={<NovayarAdmin />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;